/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Navbar,
  NavDropdown,
  Spinner,
} from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import {
  BsChevronDown,
  BsArrowDown,
  BsSearch,
  BsFillPlayFill,
  BsX,
  BsArrowLeft,
  BsPersonBadge,
} from "react-icons/bs";
import {
  FiArrowRight,
  FiExternalLink,
  FiDollarSign,
  FiClock,
  FiVideo,
  FiUserX,
  FiCheckCircle,
  FiHeart,
} from "react-icons/fi";
import Logo from "../assets/images/Motivar.svg";
import Test from "../assets/images/test.png";
import AppFooter from "../components/Footer.js";
import AppNavbar from "../components/Navbar.js";
import { Buffer } from "buffer";
import toast from "react-hot-toast";
import GeneralDataServices from "../Services/GeneralDataServices.js";
import PaymentService from "../Services/PaymentService.js";

const getInitials = (name) => {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const getSocialTitle = (url) => {
  if (!url) return "Social Profile";
  const lower = url.toLowerCase();
  if (lower.includes("linkedin.com")) return "LinkedIn Profile";
  if (lower.includes("github.com")) return "GitHub Profile";
  if (lower.includes("twitter.com") || lower.includes("x.com")) return "Twitter / X Profile";
  if (lower.includes("behance.net") || lower.includes("dribbble.com")) return "Design Portfolio";
  return "Portfolio / Social Link";
};

// --- STYLED COMPONENTS ---

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const textFade = keyframes`
  0% { opacity: 0; transform: translateY(10px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
`;

const PageWrapper = styled.div`
  background-color: #f8fafc; /* Very light cool grey */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
`;

const HeroSection = styled.div`
  background: linear-gradient(-45deg, #0f2027, #203a43, #2c5364, #11d99a);
  background-size: 400% 400%;
  animation: ${gradientAnimation} 15s ease infinite;
  padding: 100px 24px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 1400px;
  margin: 30px auto 0 auto;
  border-radius: 24px;

  @media (max-width: 768px) {
    width: calc(100% - 24px);
    padding: 48px 16px;
    margin-top: 16px;
    border-radius: 16px;
  }
`;

const GlassTitleContainer = styled.div`
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: none;
  padding: 20px 40px;
  text-align: center;
  box-shadow: none;
`;

const AnimatedTitle = styled.h1`
  color: #ffffff;
  font-weight: 800;
  font-size: clamp(1.5rem, 4vw + 0.6rem, 3rem);
  margin: 0;
  animation: ${textFade} 3s infinite;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  line-height: 1.2;
`;

const ControlsBar = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 50px;
  padding: 10px 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  margin-top: -35px;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    border-radius: 20px;
    padding: 20px;
    gap: 15px;
  }
`;

const SearchInput = styled.input`
  border: none;
  background: transparent;
  padding: 10px 15px;
  font-size: 1rem;
  font-family: "Inter", sans-serif;
  color: #333;
  flex: 1;
  outline: none;
  &::placeholder {
    color: #999;
  }
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 30px;
  padding: 5px 15px;
  flex: 0.6;
  border: 1px solid #e2e8f0;
  transition: border 0.3s;
  &:focus-within {
    border: 1px solid #11d99a;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ActionButton = styled.button`
  background: ${(props) => (props.primary ? "#11D99A" : "#ffffff")};
  color: ${(props) => (props.primary ? "#ffffff" : "#334155")};
  border: ${(props) => (props.primary ? "none" : "1px solid #cbd5e1")};
  border-radius: 30px;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    transform: translateY(-2px);
    background: ${(props) => (props.primary ? "#0ca678" : "#f8fafc")};
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const LearnerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
  gap: 30px;
  padding: 60px 0;

  @media (max-width: 768px) {
    gap: 16px;
    padding: 28px 0 40px;
  }
`;

const LearnerCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  padding: 24px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid rgba(226, 232, 240, 0.8);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(17, 217, 154, 0.15);
    border-color: rgba(17, 217, 154, 0.3);
  }
`;

const ProfileRing = styled.div`
  width: 86px;
  height: 86px;
  border-radius: 50%;
  background: linear-gradient(135deg, #11d99a, #0ca678);
  padding: 3px;
  display: inline-block;
  margin-bottom: 15px;
`;

const ProfileImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #ffffff;
`;

const LearnerName = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
`;

const CourseTitle = styled.p`
  font-size: 0.95rem;
  color: #64748b;
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
  flex: 1;
`;

const Tag = styled.span`
  background: ${(props) =>
    props.highlight ? "rgba(17, 217, 154, 0.1)" : "#f1f5f9"};
  color: ${(props) => (props.highlight ? "#099268" : "#475569")};
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;
`;

const PriceTag = styled.div`
  font-size: 1.25rem;
  font-weight: 800;
  color: #0f172a;
`;

const SponsorButton = styled.button`
  background: transparent;
  color: #11d99a;
  border: none;
  font-weight: 700;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  transition: gap 0.3s;

  &:hover {
    gap: 10px;
    color: #0ca678;
  }
`;

// --- MODAL STYLES ---

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.show ? 1 : 0)};
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  transition: all 0.3s ease;
`;

const ModalContent = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 24px;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  transform: ${(props) =>
    props.show ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)"};
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const SingleColumnModalContent = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 24px;
  width: 92%;
  max-width: 520px;
  max-height: 88vh;
  overflow-y: auto;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.35);
  transform: ${(props) =>
    props.show ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)"};
  transition: all 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

const ModalSidebar = styled.div`
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-right: 1px solid #e2e8f0;

  @media (min-width: 768px) {
    width: 35%;
  }
`;

const ModalMain = styled.div`
  padding: 40px;
  flex: 1;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: #f1f5f9;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: all 0.2s;
  z-index: 10;

  &:hover {
    background: #e2e8f0;
    color: #0f172a;
    transform: rotate(90deg);
  }
`;

const SectionTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MotivationBox = styled.div`
  background: #f8fafc;
  border-left: 4px solid #11d99a;
  padding: 20px;
  border-radius: 0 12px 12px 0;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 30px;
  white-space: pre-wrap;
`;

const PaymentOptionCard = styled.div`
  border: 2px solid ${(props) => (props.selected ? "#11D99A" : "#e2e8f0")};
  background: ${(props) =>
    props.selected ? "rgba(17, 217, 154, 0.05)" : "#ffffff"};
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 20px;

  &:hover {
    border-color: #11d99a;
    background: rgba(17, 217, 154, 0.02);
  }
`;

const OptionIconWrap = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: ${(props) => (props.selected ? "#11D99A" : "#f1f5f9")};
  color: ${(props) => (props.selected ? "#ffffff" : "#64748b")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  transition: all 0.2s;
`;

const OptionText = styled.div`
  flex: 1;
  h5 {
    margin: 0 0 4px 0;
    font-size: 1.05rem;
    font-weight: 700;
    color: #0f172a;
  }
  p {
    margin: 0;
    font-size: 0.85rem;
    color: #64748b;
  }
`;

const getCurrencySymbol = (unit) => {
  switch (unit) {
    case "NGN":
      return "₦";
    case "USD":
      return "$";
    case "GBP":
      return "£";
    default:
      return "#";
  }
};

const handleScheduleClick = async (email, name, id, price, unit, requestId) => {
  const title = encodeURIComponent(`Motivar - Sponsor Meetup with ${name}`);
  const details = encodeURIComponent(
    `Hello, ${name}. We will be meeting to discuss your interest in the course sponsorship you requested on Motivar!. Please do well to be available within the set time. Thanks!`,
  );
  const invitee = encodeURIComponent(email);
  const url = `https://calendar.google.com/calendar/u/0/r/eventedit?text=${title}&details=${details}&add=${invitee}&conference=hangouts`;
  window.open(url, "_blank");
  const payload = { name, id, price, unit, email, requestId };
  await GeneralDataServices.notifyMeetingSchedule(payload);
};

const closeSponsorModal = () => {
  setShowSponsorModal(false);
  setTimeout(() => {
    setSponsorPaymentMethod(null);
    setSelectedFundRequest(null);
  }, 300);
};

export default function AppHelpLearner() {
  const [modalShow, setModalShow] = useState(false);
  const [requests, setRequests] = useState([]);
  const [index, setIndex] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [currentText, setCurrentText] = useState("Fund a Learner's Journey");
  const [showSponsorGroupModal, setShowSponsorGroupModal] = useState(false);

  // Modal State
  const [proceedToPayment, setProceedToPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null); // 'meet' or 'anonymous'
  const router = useNavigate();

  useEffect(() => {
    setFilteredRequests(requests);
  }, [requests]);

  const handleFilter = () => {
    const filtered = requests.filter((req) => {
      const keyword = searchTerm.trim().toLowerCase();
      if (!keyword) return true;
      return (
        req.course.courseTitle?.toLowerCase().includes(keyword) ||
        req.course.platform?.toLowerCase().includes(keyword) ||
        req.motivation?.toLowerCase().includes(keyword) ||
        req.socials?.toLowerCase().includes(keyword) ||
        req.learner?.userId?.fullName?.toLowerCase().includes(keyword)
      );
    });
    setFilteredRequests(filtered);
  };

  const fetchRequests = async () => {
    try {
      const res = await GeneralDataServices.GetRequests();
      if (res) {
        setRequests(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  useEffect(() => {
    const pendingId = localStorage.getItem("pendingSponsorship");
    if (pendingId && requests.length > 0) {
      const pendingIndex = requests.findIndex((req) => req._id === pendingId);
      if (pendingIndex !== -1) {
        setIndex(pendingIndex);
        setModalShow(true);
        localStorage.removeItem("pendingSponsorship");
      }
    }
  }, [requests]);

  useEffect(() => {
    const textAlternator = setInterval(() => {
      setCurrentText((prevText) =>
        prevText === "Fund a Learner's Journey"
          ? "Support a Learner Today"
          : "Fund a Learner's Journey",
      );
    }, 3000);
    return () => clearInterval(textAlternator);
  }, []);

  const handleSponsorGroupSubmit = (e) => {
    e.preventDefault();
    toast.success("Group sponsorship submitted!");
    setShowSponsorGroupModal(false);
  };

  const openModal = (idx) => {
    setIndex(idx);
    setProceedToPayment(false);
    setPaymentMethod(null);
    setModalShow(true);
  };

  const closeModal = () => {
    setModalShow(false);
    setTimeout(() => {
      setProceedToPayment(false);
      setPaymentMethod(null);
    }, 300);
  };

  const executeSponsorship = async () => {
    if (!paymentMethod) {
      toast.error("Please select a sponsorship method.");
      return;
    }
    const learner = requests[index];
    if (!learner) return;

    try {
      var baseAmount = Number((learner.course?.price || 0) * 100) + Number(100000);
      const payload = {
        currency: learner.course?.priceUnit || "NGN",
        description: `Course payment on ${learner.course?.platform || "Motivar"}`,
        requestID: learner._id,
        amount: Number(baseAmount) + Number(baseAmount) * 0.025,
      };

      const payIntent = await PaymentService.InitiatePayment(payload);
      const paystackRef = payIntent?.data?.data?.data?.reference;

      if (paystackRef) {
        localStorage.setItem(`requestID-${paystackRef}`, learner._id);
        if (paymentMethod === "meet") {
          localStorage.setItem(
            `meetLearner-${paystackRef}`,
            JSON.stringify({
              email: learner.learner?.userId?.email,
              name: learner.learner?.userId?.fullName,
              id: learner.learner?.userId?._id,
              price: learner.course?.price,
              unit: learner.course?.priceUnit,
              requestId: learner._id,
            })
          );
        }
      }

      closeModal();

      if (payIntent?.data?.data?.data?.authorization_url) {
        window.open(
          payIntent.data.data.data.authorization_url,
          "_blank",
          "noopener,noreferrer",
        );
      } else {
        router(
          `/sponsor-status?state=pay&meet=${paymentMethod === "meet" ? "true" : "false"}&learner=${encodeURIComponent(learner.learner?.userId?.fullName || "")}&id=${encodeURIComponent(learner.learner?.userId?._id || "")}&price=${encodeURIComponent(learner.course?.price || 0)}&unit=${encodeURIComponent(learner.course?.priceUnit || "NGN")}&requestID=${encodeURIComponent(learner._id)}&email=${encodeURIComponent(learner.learner?.userId?.email || "")}`
        );
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Could not initiate payment for this request.",
      );
    }
  };

  const selectedLearner = index !== undefined ? requests[index] : null;

  return (
    <PageWrapper>
      <AppNavbar />
      <div style={{ paddingTop: "var(--navbar-height)" }}>
        <main style={{ flex: 1 }}>
          <HeroSection>
            <AnimatedTitle>{currentText}</AnimatedTitle>
          </HeroSection>

          <Container>
            <ControlsBar>
              <SearchContainer>
                <BsSearch color="#94a3b8" />
                <SearchInput
                  type="text"
                  placeholder="Search by keyword, course, or name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                />
                <ActionButton
                  primary
                  style={{ padding: "6px 12px", fontSize: "0.85rem" }}
                  onClick={handleFilter}
                >
                  Filter
                </ActionButton>
              </SearchContainer>
              <ActionsContainer>
                <ActionButton
                  onClick={() => {
                    if (requests.length > 0) {
                      const randomIndex = Math.floor(
                        Math.random() * requests.length,
                      );
                      openModal(randomIndex);
                    } else {
                      toast.error("No learners available to sponsor.");
                    }
                  }}
                >
                  Sponsor Randomly
                </ActionButton>
                <ActionButton onClick={() => setShowSponsorGroupModal(true)}>
                  Sponsor a Group
                </ActionButton>
              </ActionsContainer>
            </ControlsBar>

            <LearnerGrid>
              {filteredRequests.map((item, idx) => (
                <LearnerCard key={item._id || idx}>
                  <ProfileRing>
                    {item?.learner?.userId?.profilePicture?.data ? (
                      <ProfileImg
                        src={`data:${item.learner.userId.profilePicture.contentType};base64,${Buffer.from(item.learner.userId.profilePicture.data.data).toString("base64")}`}
                        alt="Profile"
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          backgroundColor: "#ffffff",
                          color: "var(--primary-color, #00AA87)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 800,
                          fontSize: "1.4rem",
                          letterSpacing: "1px",
                        }}
                      >
                        {getInitials(item?.learner?.userId?.fullName)}
                      </div>
                    )}
                  </ProfileRing>
                  <LearnerName>
                    {item?.learner?.userId?.fullName || "Anonymous Learner"}
                  </LearnerName>
                  <CourseTitle>
                    <FiExternalLink /> {item?.course?.courseTitle}
                  </CourseTitle>

                  <TagList>
                    <Tag>
                      <BsPersonBadge />{" "}
                      {item?.course?.platform || "Learning Platform"}
                    </Tag>
                    {item?.course?.duration && (
                      <Tag>
                        <FiClock /> {item.course.duration}{" "}
                        {item.course.durationUnit}
                      </Tag>
                    )}
                  </TagList>

                  <CardFooter>
                    <PriceTag>
                      {getCurrencySymbol(item?.course?.priceUnit)}
                      {item?.course?.price?.toLocaleString()}
                    </PriceTag>
                    <SponsorButton onClick={() => openModal(idx)}>
                      View Story <FiArrowRight />
                    </SponsorButton>
                  </CardFooter>
                </LearnerCard>
              ))}
              {filteredRequests.length === 0 && (
                <div
                  style={{
                    gridColumn: "1 / -1",
                    textAlign: "center",
                    padding: "32px 16px",
                    color: "#64748b",
                  }}
                >
                  <h5>No learners found matching your criteria.</h5>
                </div>
              )}
            </LearnerGrid>
          </Container>
        </main>

        {/* Modern Learner Details Modal */}
        <Overlay show={modalShow} onClick={closeModal}>
          <ModalContent show={modalShow} onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={closeModal}>
              <BsX size={24} />
            </CloseButton>

            {selectedLearner && !proceedToPayment && (
              <>
                <ModalSidebar>
                  <ProfileRing style={{ width: "120px", height: "120px" }}>
                    {selectedLearner?.learner?.userId?.profilePicture?.data ? (
                      <ProfileImg
                        src={`data:${selectedLearner.learner.userId.profilePicture.contentType};base64,${Buffer.from(selectedLearner.learner.userId.profilePicture.data.data).toString("base64")}`}
                        alt="Profile"
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          backgroundColor: "#ffffff",
                          color: "var(--primary-color, #00AA87)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 800,
                          fontSize: "2rem",
                          letterSpacing: "1px",
                        }}
                      >
                        {getInitials(
                          selectedLearner?.learner?.userId?.fullName,
                        )}
                      </div>
                    )}
                  </ProfileRing>
                  <h3
                    style={{
                      fontWeight: 800,
                      marginTop: "20px",
                      marginBottom: "5px",
                    }}
                  >
                    {selectedLearner?.learner?.userId?.fullName}
                  </h3>
                  <p style={{ color: "#64748b", fontSize: "0.95rem" }}>
                    {selectedLearner?.socials ? (
                      <a
                        href={
                          selectedLearner.socials.startsWith("http")
                            ? selectedLearner.socials
                            : `https://${selectedLearner.socials}`
                        }
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#11D99A",
                          textDecoration: "none",
                          fontWeight: 600,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        {getSocialTitle(selectedLearner.socials)} <FiExternalLink size={13} />
                      </a>
                    ) : (
                      "No social link provided"
                    )}
                  </p>
                  <div style={{ marginTop: "30px", width: "100%" }}>
                    <ActionButton
                      primary
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                      onClick={() => {
                        const token = localStorage.getItem("motivar-token");
                        if (!token) {
                          localStorage.setItem(
                            "pendingSponsorship",
                            selectedLearner?._id,
                          );
                          router("/user-auth");
                          return;
                        }
                        setProceedToPayment(true);
                      }}
                    >
                      <>
                        <FiHeart /> Sponsor This Learner
                      </>
                    </ActionButton>
                  </div>
                </ModalSidebar>

                <ModalMain>
                  <SectionTitle>
                    <FiExternalLink /> Course Details
                  </SectionTitle>
                  <div
                    style={{
                      display: "flex",
                      gap: "20px",
                      marginBottom: "30px",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      style={{
                        background: "#f8fafc",
                        padding: "15px 20px",
                        borderRadius: "12px",
                        flex: 1,
                        minWidth: "200px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "0.8rem",
                          color: "#64748b",
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          fontWeight: 700,
                        }}
                      >
                        Course
                      </div>
                      <div
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: 600,
                          color: "#0f172a",
                        }}
                      >
                        {selectedLearner?.course?.courseTitle}
                      </div>
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "#475569",
                          marginTop: "5px",
                        }}
                      >
                        via {selectedLearner?.course?.platform}
                      </div>
                    </div>
                    <div
                      style={{
                        background: "rgba(17, 217, 154, 0.1)",
                        padding: "15px 20px",
                        borderRadius: "12px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "0.8rem",
                          color: "#099268",
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          fontWeight: 700,
                        }}
                      >
                        Cost
                      </div>
                      <div
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: 800,
                          color: "#0ca678",
                        }}
                      >
                        {getCurrencySymbol(selectedLearner?.course?.priceUnit)}
                        {selectedLearner?.course?.price?.toLocaleString()}
                      </div>
                    </div>
                  </div>

                  <SectionTitle>
                    <BsPersonBadge /> Why I need this course
                  </SectionTitle>
                  <MotivationBox>
                    {selectedLearner?.motivation || "No motivation provided."}
                  </MotivationBox>

                  {selectedLearner?.link && selectedLearner?.link !== "N/A" && (
                    <>
                      <SectionTitle>
                        <FiExternalLink /> Course Link
                      </SectionTitle>
                      <a
                        href={
                          selectedLearner.link.startsWith("http")
                            ? selectedLearner.link
                            : `https://${selectedLearner.link}`
                        }
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#11D99A",
                          textDecoration: "none",
                          fontWeight: 600,
                        }}
                      >
                        Visit course page
                      </a>
                    </>
                  )}
                </ModalMain>
              </>
            )}

            {selectedLearner && proceedToPayment && (
              <div
                style={{
                  padding: "50px",
                  width: "100%",
                  maxWidth: "700px",
                  margin: "0 auto",
                }}
              >
                <button
                  onClick={() => setProceedToPayment(false)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#64748b",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    marginBottom: "30px",
                    padding: 0,
                  }}
                >
                  <BsArrowLeft /> Go Back
                </button>

                <h2
                  style={{
                    fontWeight: 800,
                    color: "#0f172a",
                    marginBottom: "10px",
                  }}
                >
                  Select Sponsorship Method
                </h2>
                <p style={{ color: "#64748b", marginBottom: "40px" }}>
                  How would you like to proceed with sponsoring{" "}
                  {selectedLearner?.learner?.userId?.fullName} for{" "}
                  {getCurrencySymbol(selectedLearner?.course?.priceUnit)}
                  {selectedLearner?.course?.price?.toLocaleString()}?
                </p>

                <PaymentOptionCard
                  selected={paymentMethod === "meet"}
                  onClick={() => setPaymentMethod("meet")}
                >
                  <OptionIconWrap selected={paymentMethod === "meet"}>
                    <FiVideo />
                  </OptionIconWrap>
                  <OptionText>
                    <h5>Meet the Learner</h5>
                    <p>
                      Proceed to payment, then schedule a virtual meeting with the learner.
                    </p>
                  </OptionText>
                  {paymentMethod === "meet" && (
                    <FiCheckCircle color="#11D99A" size={24} />
                  )}
                </PaymentOptionCard>

                <PaymentOptionCard
                  selected={paymentMethod === "anonymous"}
                  onClick={() => setPaymentMethod("anonymous")}
                >
                  <OptionIconWrap selected={paymentMethod === "anonymous"}>
                    <FiUserX />
                  </OptionIconWrap>
                  <OptionText>
                    <h5>Stay Anonymous</h5>
                    <p>
                      Proceed directly to payment without scheduling a meeting.
                    </p>
                  </OptionText>
                  {paymentMethod === "anonymous" && (
                    <FiCheckCircle color="#11D99A" size={24} />
                  )}
                </PaymentOptionCard>

                <div
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <ActionButton
                    primary
                    style={{ padding: "15px 30px", fontSize: "1rem" }}
                    onClick={executeSponsorship}
                  >
                    Continue to Payment <FiArrowRight />
                  </ActionButton>
                </div>
              </div>
            )}
          </ModalContent>
        </Overlay>

        {/* Group Sponsor Modal */}
        <Overlay
          show={showSponsorGroupModal}
          onClick={() => setShowSponsorGroupModal(false)}
        >
          <SingleColumnModalContent
            show={showSponsorGroupModal}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ padding: "32px 28px" }}>
              <CloseButton
                style={{ top: "20px", right: "20px" }}
                onClick={() => setShowSponsorGroupModal(false)}
              >
                <BsX size={24} />
              </CloseButton>

              {/* Header */}
              <div className="mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center mb-3 rounded-3"
                  style={{
                    width: "44px",
                    height: "44px",
                    backgroundColor: "rgba(0, 170, 135, 0.12)",
                    color: "#00AA87",
                  }}
                >
                  <BsPersonBadge size={22} />
                </div>
                <h3
                  style={{
                    fontFamily: "'Manrope', sans-serif",
                    fontWeight: 800,
                    color: "#0F172A",
                    fontSize: "1.5rem",
                    marginBottom: "6px",
                  }}
                >
                  Sponsor a Group / Cohort
                </h3>
                <p
                  style={{
                    color: "#475569",
                    fontSize: "0.9rem",
                    margin: 0,
                    fontWeight: 500,
                  }}
                >
                  Provide direct sponsorship to a targeted cohort or group of
                  learners.
                </p>
              </div>

              <Form onSubmit={handleSponsorGroupSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label
                    style={{
                      fontWeight: 700,
                      color: "#0F172A",
                      fontSize: "0.9rem",
                    }}
                  >
                    Number of Learners
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="e.g. 10"
                    required
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #CBD5E1",
                      fontSize: "0.95rem",
                      minHeight: "46px",
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label
                    style={{
                      fontWeight: 700,
                      color: "#0F172A",
                      fontSize: "0.9rem",
                    }}
                  >
                    Target Group / Community
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. Women in Tech, Underrepresented Youth"
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #CBD5E1",
                      fontSize: "0.95rem",
                      minHeight: "46px",
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label
                    style={{
                      fontWeight: 700,
                      color: "#0F172A",
                      fontSize: "0.9rem",
                    }}
                  >
                    Target Track / Field
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. Data Science, Web Development"
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #CBD5E1",
                      fontSize: "0.95rem",
                      minHeight: "46px",
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label
                    style={{
                      fontWeight: 700,
                      color: "#0F172A",
                      fontSize: "0.9rem",
                    }}
                  >
                    Additional Notes & Special Requirements
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Any specific location, criteria, or cohort preferences..."
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #CBD5E1",
                      fontSize: "0.95rem",
                      resize: "vertical",
                    }}
                  />
                </Form.Group>

                <ActionButton
                  primary
                  type="submit"
                  style={{
                    width: "100%",
                    justify: "center",
                    minHeight: "48px",
                    borderRadius: "999px",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    gap: "8px",
                  }}
                >
                  Submit Group Sponsorship Request <FiArrowRight size={18} />
                </ActionButton>
              </Form>
            </div>
          </SingleColumnModalContent>
        </Overlay>
      </div>

      <AppFooter />
    </PageWrapper>
  );
}
